// extracted by mini-css-extract-plugin
export default {"listitem":"ArtikelListItem_listitem__GcYuO","artikellistitem":"ArtikelListItem_artikellistitem__nA1AY","main":"ArtikelListItem_main__aQk3V"};